import { customerBaseApi } from "@/react/services/api";
import { TOKEN_GENERATOR } from "@/react/routing/constants";
import { HttpMethods } from "@/react/http";

const tokenGeneratorBaseUrl = "token";

export const tokenGeneratorApi = customerBaseApi.injectEndpoints({
  reducerPath: "tokenGeneratorApi",
  endpoints: (builder) => ({
    generateToken: builder.query({
      query: ({ expirationInSeconds }) => ({
        url: tokenGeneratorBaseUrl,
        method: HttpMethods.POST,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(expirationInSeconds), // Send as raw number, as TAP BE expects
      }),
      invalidatesTags: [TOKEN_GENERATOR],
    }),
  }),
});

export const { useLazyGenerateTokenQuery } = tokenGeneratorApi;
